export enum AutoclaveTypeId {
  Steam = 10,
  DriHeat = 9,
  Chemical = 11,
  eTo = 12,
}

export enum AutoclaveSelection {
  TestResults = 'test-results',
  TestLogs = 'test-result-logs',
}

export enum SporetestLogAction {
  Create = 'created',
  Update = 'updated',
  Remove = 'removed'
}
